import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Download, FileEarmarkFill } from "react-bootstrap-icons";
import { useCachedFile } from "@/shared/lib/use-cached-file";
import { downloadFile, FileItem } from "@/shared/lib";

interface TextFileProps {
  file: FileItem;
  isSelected?: boolean;
  onClick?: (url: string) => void;
}

const formatFileSize = (size: number) => {
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / 1024 / 1024).toFixed(1)} MB`;
};

export const TextFile: React.FC<TextFileProps> = ({ file, isSelected, onClick }) => {
  const [hovered, setHovered] = useState(false);

  const { cachedFile } = useCachedFile(typeof file === "string" ? file : undefined);
  const fileUrl = typeof file === "string" ? file : URL.createObjectURL(file);
  const finalUrl = cachedFile?.url || fileUrl;

  const name = typeof file === "string" ? file.split("/").pop()?.split(".")[0] || "file" : file.name.split(".").shift();
  const ext =
    typeof file === "string"
      ? file.split(".").pop()?.toUpperCase() || "FILE"
      : file.name.split(".").pop()?.toUpperCase() || "FILE";

  const size = cachedFile?.blob.size || (file instanceof File ? file.size : undefined);
  const formattedSize = size ? formatFileSize(size) : "";
  return (
    <div
      title={ext}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        maxWidth: 250,
        position: "relative",
        cursor: "pointer",
      }}
    >
      <div
        className="px-2 rounded-4"
        style={{
          opacity: hovered ? 0.9 : 1,
          backgroundColor: isSelected ? "#3284ff" : "#a5a5a5",
          color: isSelected ? "#fff" : "#555",
          fontWeight: "bold",
          fontSize: 12,
          height: 50,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          transition: "opacity 0.25s ease",
        }}
      >
        <div
          className="d-flex justify-content-start align-items-center"
          style={{ width: "100%" }}
        >
          <Button
            size="sm"
            variant="secondary"
            onClick={(e) => {
              if (!hovered || !finalUrl) return;

              e.stopPropagation();
              e.preventDefault();
              const filename =
                typeof file === "string" ? file.split("/").pop() || "file" : file.name;
              downloadFile(finalUrl, filename);
            }}
            style={{
              width: 32, height: 32,
              padding: 0, marginRight: 6,
              display: "flex", alignItems: "center", justifyContent: "center",
              flexShrink: 0,
            }}
          > {hovered && finalUrl ?

            <Download size={18} />
            :
            <FileEarmarkFill fontSize={18} />
            }
          </Button>

          <div className="d-flex flex-column" style={{ width: "calc(100% - 42px)" }} >
          <div className="d-flex" style={{ width: "100%" }} >
            <div
              className="text-truncate"
              style={{ overflow: "hidden", whiteSpace: "nowrap", flexShrink: 1 }}
            >
              {name}
            </div>
            <span style={{ flexShrink: 0 }}>.{ext}</span>
          </div>

          {formattedSize && (
            <div style={{ fontSize: 11 }}>
              {formattedSize}
            </div>
          )}
        </div>
        </div>
      </div>
    </div>
  );
};
